window.jui.ColorMath = {
  blendFilters: {
    multiply: function(a, b) {
      return b * a / 255;
    },
    screen: function(a, b) {
      return 255 - ((255 - b) * (255 - a) >> 8);
    },
    overlay: function(a, b) {
      return a < 128 ? 2 * b * a / 255 : 255 - 2 * (255 - a) * (255 - b) / 255;
    },
    dodge: function(a, b) {
      return parseInt(a, 10) === 255 ? a : Math.min(255, (b << 8) / (255 - a));
    },
    burn: function(a, b) {
      return parseInt(a, 10) === 0 ? a : Math.max(0, 255 - (255 - b << 8) / a);
    },
    negate: function(a, b) {
      return 255 - Math.abs(255 - a - b);
    },
    median: function(a, b) {
      return Math.round((a + b) / 2);
    }
  },

  applyFilter: function(fromColor, toColor, blendFilter) {
    return [
      blendFilter(fromColor[0], toColor[0]),
      blendFilter(fromColor[1], toColor[1]),
      blendFilter(fromColor[2], toColor[2])
    ];
  },

  blend: function(filter, fromColor, toColor) {
    var blendFilter = window.jui.ColorMath.blendFilters[filter];
    filter = window.jui.ColorMath.applyFilter(fromColor, toColor, blendFilter);
    return [
      Math.min(Math.round(filter[0]), 255),
      Math.min(Math.round(filter[1]), 255),
      Math.min(Math.round(filter[2]), 255)
    ];
  },

  hexToRgb: function(hex) {
    var r, g, b;

    if (hex.length === 3) {
      r = parseInt((hex).substring(0,1),16);
      g = parseInt((hex).substring(1,2),16);
      b = parseInt((hex).substring(2,3),16);
      r += r * 16;
      g += g * 16;
      b += b * 16;
    } else {
      r = parseInt((hex).substring(0,2),16);
      g = parseInt((hex).substring(2,4),16);
      b = parseInt((hex).substring(4,6),16);
    }

    return [r,g,b];
  },

  normalizeHexValue: function(hex) {
    if(hex.length === 6) {return hex;}
    var sixCharHex = [hex[0], hex[0], hex[1], hex[1], hex[2], hex[2]];
    return sixCharHex.join('');
  },

  rgbToHex: function(rgb) {
    rgb = (rgb[2] | rgb[1] << 8 | rgb[0] << 16).toString(16);
    return "000000".substr(0, 6 - rgb.length) + rgb;
  },

  rgbaRegex: new RegExp(/^rgba\(.*\)/gi),

  isRgba: function(cssColor) {
    return this.rgbaRegex.test(cssColor);
  },

  cssToRgb: function(cssColor) {
    var regex = new RegExp(/^rgb\(.*\)/gi);
    return regex.test(cssColor) ? this.getColorAsArrayFromRgbString(cssColor) :
      this.hexToRgb(cssColor.replace('#', ''));
  },

  getColorAsArrayFromRgbString: function(cssString) {
    var colorParts = cssString.substring(4, cssString.length - 1).split(',');
    return colorParts.map(function(colorPart) {
      return parseInt(colorPart.trim(), 10);
    });
  },

  rgbToCss: function(rgb) {
    return "rgb(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ")";
  },

  rgbaToCss: function(rgb, alpha) {
    return "rgba(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + "," + alpha + ")";
  },

  decimalAlphaToHex: function(alpha) {
    return Math.floor(alpha * 255).toString(16);
  },

  rgbToHsv: function(a) {
    var b = a[0] / 255,
        c = a[1] / 255,
        d = a[2] / 255,
        e = Math.min(b, c, d);
    a = Math.max(b, c, d);

    if (a === e) {
      return [0, 0, a];
    }

    var f = (a - b) / (a - e),
        g = (a - c) / (a - e);
    d = (a - d) / (a - e);
    var h = b === a ? d - g : c === a ? 2 + f - d : 4 + g - f;
    h = h / 6 % 1;
    if (h < 0) {
      h += 1;
    }
    return [h, (a - e) / a, a];
  },

  hsvToRgb: function(a) {
    var b = a[0],
        c = a[1];
    a = a[2] * 255;

    if (c === 0) {
      return [a, a, a];
    }

    var d = Math.floor(b * 6),
        e = b * 6 - d,
        f = a * (1 - c * e);
    b = a * (1 - c);
    c = a * (1 - c * (1 - e));
    d %= 6;

    return [[a, c, b],
            [f, a, b],
            [b, a, c],
            [b, f, a],
            [c, b, a],
            [a, b, f]][d];
  },

  rgbToHsl: function(a) {
    var b = a[0] / 255,
        c = a[1] / 255,
        d = a[2] / 255,
        e = Math.min(b, c, d),
        f = (e + a) / 2;
    a = Math.max(b, c, d);

    if (e === a) {
      return [0, 0, f];
    }

    var g = (a - b) / (a - e),
        i = (a - c) / (a - e);
    d = (a - d) / (a - e);
    b = (b === a ? d - i : c === a ? 2 + g - d : 4 + i - g) / 6 % 1;
    if (b < 0) {
      b += 1;
    }
    return [b, f <= 0.5 ? (a - e) / (a + e) : (a - e) / (2 - a - e), f];
  },

  hueToRgb: function(a, b, c) {
    if (c < 0) {
      c += 1;
    }
    if (c > 1) {
      c -= 1;
    }
    return 6 * c < 1 ? a + (b - a) * 6 * c : 2 * c < 1 ? b : 3 * c < 2 ? a + (b - a) * (2 / 3 - c) * 6 : a;
  },

  invert_rgb: function(a) {
    return [255 - a[0], 255 - a[1], 255 - a[2]];
  },

  calculateGradient: function(startColor) {
    var rgbColor = this.hexToRgb(startColor);
    var colorBlend = this.getColorBlend(rgbColor);
    // In order for the auto-generated gradient to look its best
    // across many different hues, we need to blend with a
    // derivative of the original colour. By manipulating only
    // the saturation and brightness (subtracting 10% from both)
    // and then doing a "multiply" blend on top of the original
    // colour, we can arrive at a decent looking bottom gradient
    // colour for all hues.
    var endColor = this.rgbToHex(this.blend("multiply", rgbColor, colorBlend));

    return {from: startColor, to: endColor};
  },

  getColorBlend: function(rgbColor) {
    var hsvColor = this.rgbToHsv(rgbColor);
    return this.hsvToRgb([
      hsvColor[0],
      Math.max(0, hsvColor[1] - 0.1),
      Math.max(0, hsvColor[2] - 0.1)
    ]);
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/jui/color_math.js
// module id = 265
// module chunks = 0 1